import React from 'react';
import { useTranslation } from 'react-i18next';
import ModalShell from 'shared/components/ui/ModalShell';
import { buttonClasses } from 'styles/tailwindClassnames';

// Confirmations render through the shared ModalShell rather than window.confirm,
// so they match every other dialog in the portal.
export type Confirmation = {
  title: string;
  body: string;
  confirmLabel: string;
  destructive?: boolean;
  onConfirm: () => void;
};

const ConfirmationModal = ({
  confirmation,
  onClose,
}: {
  confirmation: Confirmation;
  onClose: () => void;
}) => {
  const { t } = useTranslation();
  return (
    <ModalShell
      title={confirmation.title}
      onClose={onClose}
      footer={
        <>
          <button
            type="button"
            className={
              confirmation.destructive
                ? buttonClasses.destructiveAction
                : buttonClasses.primaryAction
            }
            onClick={() => {
              const run = confirmation.onConfirm;
              onClose();
              run();
            }}
          >
            {confirmation.confirmLabel}
          </button>
          <button
            type="button"
            className={buttonClasses.cancelAction}
            onClick={onClose}
          >
            {t('Cancel')}
          </button>
        </>
      }
    >
      <p className="text-body-md text-ui-text-primary-text">
        {confirmation.body}
      </p>
    </ModalShell>
  );
};

export default ConfirmationModal;
